namespace Ir.Components.Workbook.Settings.WidgetSpecificSettings {
    interface IViewModel {
        config: WorkbookConfig;
        dxScrollConfig: any;
        activeTabItem: KnockoutObservable<SettingTabVM>;
        widgetType: KnockoutComputed<WidgetType>;
    }
    
    export function getViewModel(this: IViewModel, params: any) {
        this.config = params.config as WorkbookConfig;
        this.activeTabItem = params.activeTabItem;
        this.dxScrollConfig = {
            useNative: false,
        };
        this.widgetType = ko.computed(() => {
            let drilldownManager = this.config.activeTabOrWidget().drilldownManager;
            if (drilldownManager.isDifferentWidgetType) {
                return drilldownManager.getActiveWidget().widgetType;
            }
            else {
                return this.config.activeTabOrWidget().widgetType();
            }
        });
    }
}